module.exports = __webpack_public_path__ + "img/france.54826494.svg";